export default __webpack_public_path__ + "static/media/cpp.4cbeff20.png";